var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { validateDateOrder, validateDate } from './validateDateTime';
import validateHoursOfOperation from './validateHoursOfOperation';
import validateExceptions from './validateExceptions';
/** Require a given key */
function required(values, key) {
    var _a;
    if (!(key in values) ||
        values[key] === undefined ||
        (typeof values[key] === 'string' &&
            values[key].trim() === '') ||
        (Array.isArray(values[key]) &&
            values[key].filter(function (a) { return a; }).length === 0)) {
        return _a = {},
            _a[key] = React.createElement(FormattedMessage, { id: "stripes-core.label.missingRequiredField" }),
            _a;
    }
    return {};
}
/** Run all validation functions */
export default function validate(localeDateFormat, localeTimeFormat, dateRefs, innerFieldRefs, values) {
    // in reverse order of priority, later objects will unpack on top of earlier ones
    // therefore, required should take precedence over any other errors
    return __assign(__assign(__assign(__assign(__assign(__assign({}, validateHoursOfOperation(values['hours-of-operation'], innerFieldRefs.hoursOfOperation, localeTimeFormat)), validateExceptions(values.exceptions, innerFieldRefs.exceptions, localeDateFormat, localeTimeFormat)), validateDateOrder(values)), required(values, 'name')), validateDate(values, 'start-date', dateRefs.startDateRef, localeDateFormat)), validateDate(values, 'end-date', dateRefs.endDateRef, localeDateFormat));
}
